import React, { useState, useEffect } from 'react';
import { Spin, Table, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { type AppDispatch } from '../../../redux/store';
import { getBranchTransferAction } from '../store/investmentActions';
import { type BranchTransferResponse } from '../store/investmentTypes';
import dayjs from 'dayjs';
import fmt from 'indian-number-format';

export default function BranchTransferTableIndex(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();
  const { branchTransfers }: any = useSelector<any>(
    (state) => state?.investment
  );

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [branch, setBranch] = useState<any>('');
  const [branchOptions, setBranchOptions] = useState<
    Array<{
      label: string;
      value: string;
    }>
  >([]);

  useEffect(() => {
    const branches = localStorage.getItem('branches');
    if (branches != null) {
      const parsedBranches = JSON.parse(branches);
      const branchOptionTemp: Array<{ label: string; value: string }> =
        parsedBranches.map((branch: { code: string; id: string }) => ({
          label: branch.code,
          value: branch.id,
        }));
      setBranchOptions(branchOptionTemp);
      setBranch(parsedBranches[0].id);
    }
  }, []);

  const getTransfers = async (): Promise<void> => {
    setIsLoading(true);
    await getBranchTransferAction(dispatch, { branch });
    setIsLoading(false);
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (branch) {
      void getTransfers();
    }
  }, [branch]);

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      render: (_: any, record: BranchTransferResponse, index: number) =>
        index + 1,
      width: 50,
    },
    {
      title: 'From Branch',
      dataIndex: 'fromBranch',
      key: 'fromBranch',
      render: (_: any, record: BranchTransferResponse) => (
        <p>{record.fromBranch?.code}</p>
      ),
    },
    {
      title: 'To Branch',
      dataIndex: 'toBranch',
      key: 'toBranch',
      render: (_: any, record: BranchTransferResponse) => (
        <p>{record.toBranch?.code}</p>
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_: any, record: BranchTransferResponse) => (
        <p>{fmt.format(record.amount)}</p>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (_: any, record: BranchTransferResponse) => (
        <p>{record.description}</p>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'Date',
      key: 'Date',
      render: (_: any, record: BranchTransferResponse) => (
        <p>{dayjs(String(record.transactionDate)).format('DD-MM-YYYY')}</p>
      ),
    },
  ];

  return (
    <div className="investment__table__page">
      <Spin spinning={isLoading} fullscreen />
      <h4>Branch</h4>
      <Select
        value={branch}
        onChange={(value: string): void => {
          setBranch(value);
        }}
        style={{ width: 311 }}
        placeholder="Select branch"
        options={branchOptions}
        className="deposit__input"
      />
      {Boolean(branchTransfers.length) && (
        <div style={{ width: '100%' }}>
          <Table
            dataSource={branchTransfers}
            columns={columns}
            rowKey={(record: BranchTransferResponse) => record?._id}
            rowClassName={(record: BranchTransferResponse) => {
              if (record.fromBranch?._id === branch) return 'row-red';
              if (record.toBranch?._id === branch) return 'row-green';
              return '';
            }}
          />
        </div>
      )}
    </div>
  );
}
